export const InvoiceDivision = [
  { label: '課税事業者', value: '1' },
  { label: '免税事業者', value: '2' },
];
